import $ from 'jquery';

export const accordion = ($accordionToggle) => {
    $accordionToggle.off('click');
    $accordionToggle.on('click', function () {
        toggleAccordion($accordionToggle);
    });
};

export const toggleAccordion = ($accordionToggle) => {
    const $body = $accordionToggle.closest('.accordion').children('.accordion__body');

    if ($accordionToggle.hasClass('accordion__toggle--active')) {
        $accordionToggle.removeClass('accordion__toggle--active');
        $accordionToggle.attr('aria-expanded','false');
        $body.find('.accordion__toggle--active').trigger('click');
        $body.find('.accordion__toggle--active').trigger('change');
        $body.removeClass('accordion__body--active').one('transitionend', function () {
            $body.slideUp(300);
        });
    } else {
        $body.slideDown(300, function () {
            $accordionToggle.addClass('accordion__toggle--active');
            $accordionToggle.attr('aria-expanded','true');
            $body.addClass('accordion__body--active');
        });
    }
};


export const reloadScriptAccordion = () => {
    const $accordionToggle = $('.accordion__toggle');

    if ($accordionToggle.length > 0) {
        $accordionToggle.each(function () {
            accordion($(this));
        });
    }
};
reloadScriptAccordion();
